<template>
  <p>{{ content }}</p>
</template>

<script>
import moment from "moment";
export default {
  name: "x-time",
  data(){
    return {
      content: ''
    }
  },
  props: {
    value: {
      type: String | Number,
      required: true,
      default: new Date().toString()
    },
    format: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss"
    }
  },
  watch:{
    'value': {
      handler:function (newVal, oldVal){
        this.diffTime()
      },
      deep: true
    }
  },
  mounted() {
    this.diffTime()
  },
  methods: {
    diffTime(){
      let value = this.value
      // let value = "2022-05-22 15:04:05"
      let date = new Date(value)
      let now = new Date()
      let diff = now.getTime() - date.getTime()
      let mill = 1
      let sec = 1000 * mill
      let min = 60 * sec
      let hour = 60 * min
      let day = 24 * hour
      if (diff < min) {
        this.content = '刚刚'
      }else if (diff < hour){
        this.content = Math.floor(diff / min)+ '分钟前'
      }else if (diff < day){
        this.content = Math.floor(diff / hour)+ '小时前'
      }else if (diff < (day * 7)){
        this.content = Math.floor(diff / day)+ '天前'
      }else{
        this.content = moment(date.getTime()).format(this.format)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
}
</style>